import axiosClient from '@/config/api/axios'
import { INTEGRATION_CONNECTIONS } from '@/config/api/endpoints'
import { connectionSchema } from '@/schemas/integrations/connection'

/**
 * Read one connection's provider status.
 *
 * This is the only thing that establishes whether a connect succeeded — the
 * parameters Composio appends when it returns the browser are never trusted.
 *
 * @param {{ connectionId: string, workspaceId?: string, signal?: AbortSignal }} options
 */
export async function getConnection({ connectionId, workspaceId, signal }) {
  const { data } = await axiosClient.get(
    `${INTEGRATION_CONNECTIONS}/${encodeURIComponent(connectionId)}`,
    { signal, headers: workspaceId ? { 'X-Workspace-Id': workspaceId } : undefined },
  )
  return connectionSchema.parse(data)
}
